// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"b4bf6df1","595":"b59e530d","857":"93534620"}[chunkId] + ".js";
};